<template>
    <span
      class="pointer"
      @click="onChange"
    >
      <v-icon
        v-if="value==='asc'"
        :small="small"
      >mdi-sort-ascending</v-icon>
      <v-icon
        v-else
        :small="small"
      >mdi-sort-descending</v-icon>
    </span>
</template>

<script>
export default {
  name: 'OrderTo',
  props: {
    value: {
      type: String,
      default: 'asc',
    },
    small: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onChange() {
      const status = (this.value === 'asc') ? 'desc' : 'asc';
      this.$emit('input', status);
    },
  },
};
</script>

<style scoped>

</style>
